import { postJson } from './client';

export interface FiltersAssistantResponse {
  text: {
    type: 'keywords' | 'collection' | 'unknown';
    content: string;
    records: AssistantResponseRecord[];
    record_types?: string;
    filter_types?: string;
    raw: string;
    error?: string;
  };
}

export interface AssistantResponseRecord {
  record_type:
    | 'Feature'
    | 'Requirement'
    | 'Release'
    | 'Task'
    | 'Ideas::Idea'
    | 'Epic';
  record_type_display: string;
  reference_num: string;
  name: string;
  url: string;
  report_url: string;
}

interface FiltersAssistantRequest {
  prompt: string;
  previousMessages?: { role: 'assistant' | 'user'; text: string }[];
}

function filtersAssistant(
  request: FiltersAssistantRequest,
  signal?: AbortSignal
): Promise<FiltersAssistantResponse> {
  return postJson('/assistances/search_filters_assistant.json', {
    signal,
    body: {
      prompt: request.prompt,
      context: {
        messages: request.previousMessages || [],
      },
    },
  });
}

export const assistances = {
  filtersAssistant,
};
